export let config = {
  baseUrl: 'https://blog.slayhop.com/api/',
  imgBaseUrl: 'https://blog.slayhop.com',
  captchaKey: '6LciWGQqAAAAAM4Saer2QkkXsZKDokm6llizHUyq',
  apiUrl: 'https://contact.slayhop.com/api/web',
  contactURL: 'https://api.slayhop.com',
};
